import { createContext } from 'reka-ui'

export interface CredenzaContext {
  isMobile: Ref<boolean>;
  dismissable: Ref<boolean>;
  dismissOnEscape: Ref<boolean>;
  fullScreen: Ref<boolean>;
  showDragHandle: Ref<boolean>;
  showCloseButton: Ref<boolean>;
  dragProgress: Ref<number>;
  /**
   * Whether opening and closing are performances. Off, the credenza is simply where it is —
   * for a consumer whose open state is a fact on arrival (a URL that names it) rather than
   * something the student just did.
   */
  animated: Ref<boolean>;
}

export const [useCredenzaContext, provideCredenzaContext] = createContext<CredenzaContext>('Credenza')
